import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router';
import {
  PUBLIC_OFFER_REQUISITES,
  PUBLIC_OFFER_SECTIONS,
  PUBLIC_OFFER_SUBTITLE,
  PUBLIC_OFFER_TITLE,
} from '@/content/legal/public-offer';
import { resolveLegalReturnTo } from '@/features/legal/legal-navigation';
import { MiniappSurface } from '@/shared/components/ui/MiniappSurface';
import { PageFrame } from '@/shared/components/ui/PageFrame';
import { StackHeader } from '@/shared/components/ui/StackHeader';

export function PublicOfferPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const returnTo = resolveLegalReturnTo(location.search, '/legal');

  const handleBack = useCallback(() => {
    void navigate(returnTo);
  }, [navigate, returnTo]);

  return (
    <PageFrame
      container="readable-content"
      topInset="stack"
      bottomInset="none"
      className="space-y-4 pb-6"
    >
      <StackHeader onBack={handleBack} label="Документы" title="Публичная оферта" />

      <MiniappSurface className="space-y-4 px-5 py-5">
        <div className="space-y-2">
          <h1 className="text-[24px] font-black uppercase leading-[0.92] tracking-[0.02em] text-[var(--foreground)]">
            {PUBLIC_OFFER_TITLE}
          </h1>
          <p className="text-[14px] leading-6 text-[rgba(26,26,26,0.62)]">
            {PUBLIC_OFFER_SUBTITLE}
          </p>
          <p className="text-[13px] leading-5 text-[rgba(26,26,26,0.58)]">
            Актуальная редакция договора об оказании услуг для пользователей INHOUND.
          </p>
        </div>
      </MiniappSurface>

      {PUBLIC_OFFER_SECTIONS.map((section) => (
        <MiniappSurface key={section.title} className="space-y-3 px-5 py-5">
          <h2 className="text-[16px] font-black uppercase tracking-[0.02em] text-[var(--foreground)]">
            {section.title}
          </h2>

          <div className="space-y-3 text-[14px] leading-6 text-[rgba(26,26,26,0.74)]">
            {section.paragraphs?.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}

            {section.bullets && (
              <ul className="space-y-2">
                {section.bullets.map((bullet) => (
                  <li key={bullet} className="flex gap-2">
                    <span className="pt-[0.35rem] text-[var(--accent)]">•</span>
                    <span>{bullet}</span>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </MiniappSurface>
      ))}

      <MiniappSurface className="space-y-3 px-5 py-5">
        <h2 className="text-[16px] font-black uppercase tracking-[0.02em] text-[var(--foreground)]">
          Реквизиты исполнителя
        </h2>
        <ul className="space-y-2 text-[14px] leading-6 text-[rgba(26,26,26,0.74)]">
          {PUBLIC_OFFER_REQUISITES.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </MiniappSurface>
    </PageFrame>
  );
}
